<template>
  <div class="sv-page">
    <header class="sv-page-header">
      <div>
        <span class="sv-page-header__eyebrow">Administração da plataforma</span>
        <h1>Configurações</h1>
        <p>Organize operações, integrações e informações da empresa.</p>
      </div>
    </header>

    <div class="row">
      <div class="col-xxl-12">
        <ListOperations />
      </div>
      <div class="col-xxl-12">
        <FormUpdateCompany />
      </div>
    </div>
  </div>
</template>

<script lang="ts"> 
import { defineComponent } from "vue";

import ListOperations from "../../components/Configurations/ListOperations.vue";
import FormUpdateCompany from "../../components/Configurations/FormUpdateCompany.vue";

export default defineComponent({
  name: "ListOperationsPage",
  components: {
    FormUpdateCompany,
    ListOperations
  },
});
</script>
